import { DAPI_HOST } from '../../config';
import { BookingStatus, UPCOMING_BOOKING_STATUSES } from '../../constants';
import { queryStringFromObject } from '../util/string';

const getCreateAccountUrl = () => `${DAPI_HOST}/v1/accounts/`;

const getAccountById = accountId => `${DAPI_HOST}/v1/accounts/${accountId}`;

const getSaveLocationUrl = accountId => `${DAPI_HOST}/v1/accounts/${accountId}/save-for-later`;

const getAccountByPhoneNumberUrl = phone => `${DAPI_HOST}/v1/accounts/phone-number/${phone}`;

const getAccountSummaryById = (accountId, activeOnly = true) =>
  `${DAPI_HOST}/v1/accounts/${accountId}/summary?active_only=${activeOnly}`;

const addNewFavoriteClinic = () => `${DAPI_HOST}/v1/user-profile-location-favorites/`;

const deleteFavoriteClinic = userProfileLocationFavoriteId =>
  `${DAPI_HOST}/v1/user-profile-location-favorites/${userProfileLocationFavoriteId}`;

const getAppointmentsForUserProfileUrl = userProfileId =>
  `${DAPI_HOST}/v1/bookings/?user_profile_id=${userProfileId}&limit=100&filters=bookings.status:${
    BookingStatus.DISCHARGED
  },${UPCOMING_BOOKING_STATUSES.join(',')}&order_by=appointment_date%20ASC`;

const buildDapiAccountObject = form => {
  const account = {};
  for (const field in form) {
    if (form.hasOwnProperty(field)) {
      switch (field) {
        case 'firstName':
          account.first_name = form.firstName;
          break;
        case 'lastName':
          account.last_name = form.lastName;
          break;
        case 'email':
          account.email = form.email;
          break;
        default:
          break;
      }
    }
  }

  return account;
};

const getRequiresPhoneVerificationUrl = phone =>
  `${DAPI_HOST}/v1/accounts/requires_phone_verification?${queryStringFromObject({ phone })}`;

const getVerificationStatus = phone =>
  `${DAPI_HOST}/v1/accounts/verification_status?${queryStringFromObject({
    phone,
  })}`;

const getRebookingTestUrl = bookingId => `${DAPI_HOST}/v1/bookings/${bookingId}/rebooking-test`;

const ACCOUNT_EXISTS_ERROR_DESCRIPTION = 'Account already exists for the phone number provided.';

const setSolvTosAccepted = accountId => `${DAPI_HOST}/v1/accounts/${accountId}/solv-tos-accepted`;

export {
  getAccountById,
  getCreateAccountUrl,
  getRebookingTestUrl,
  addNewFavoriteClinic,
  deleteFavoriteClinic,
  buildDapiAccountObject,
  getAccountSummaryById,
  getAppointmentsForUserProfileUrl,
  getSaveLocationUrl,
  getRequiresPhoneVerificationUrl,
  getAccountByPhoneNumberUrl,
  getVerificationStatus,
  setSolvTosAccepted,
  ACCOUNT_EXISTS_ERROR_DESCRIPTION,
};
